export default __webpack_public_path__ + "static/media/la_ferte-vidame06.d53a4953.jpg";